import { createContext } from 'react';
export var PopupContext = createContext({
    isInPopup: false,
    setScrollableContentRef: function (node) {
        /* noop */
    },
    /* DO NOT USE THIS - If you are using ModalLayout */
    setDefaultScrollableRef: function (node) {
        /* noop */
    },
});
PopupContext.displayName = 'PopupContext';
//# sourceMappingURL=PopupContext.js.map